import React, { useState, useContext, useEffect } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { HomeContext } from '../Context/HomeContext';
import { Offcanvas } from 'bootstrap';
import { FaBarsStaggered } from 'react-icons/fa6';
import './Header.css';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { homeData, loading } = useContext(HomeContext);
  const [openSubcategories, setOpenSubcategories] = useState({});
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleSearch = () => {
    if (!searchTerm.trim()) return;
    closeOffcanvas();            // ✅ Close the sidebar menu
    setIsModalOpen(false);       // ✅ Close the search modal
    navigate(`/search?q=${encodeURIComponent(searchTerm.trim())}`); // ✅ Use navigate()
    setIsModalOpen(false);
    setSearchTerm('');
  };

  const handleSearchKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };


  const categories = homeData?.allCategories ? Object.values(homeData.allCategories) : [];

  useEffect(() => {
    if (!menuOpen) {
      const backdrop = document.querySelector('.offcanvas-backdrop');
      if (backdrop) backdrop.remove();

      // Reset all subcategory states
      setOpenSubcategories({});
    }
  }, [menuOpen]);

  const closeOffcanvas = () => {
    const offcanvasElement = document.getElementById('offcanvasWithBothOptions');
    if (offcanvasElement) {
      const offcanvas = Offcanvas.getInstance(offcanvasElement);
      if (offcanvas) offcanvas.hide();
    }

    setTimeout(() => {
      const backdrop = document.querySelector('.offcanvas-backdrop');
      if (backdrop) backdrop.remove();

      setOpenSubcategories({}); // ✅ Reset submenus
    }, 300);

    setMenuOpen(false);
  };


  const handleCategoryClick = (slug) => {
    navigate(`/category/${slug}`);
    closeOffcanvas();
  };

  const handleSubcategoryClick = (slug, e) => {
    e.stopPropagation();
    navigate(`/subcategory/${slug}`);
    closeOffcanvas();
  };

  const toggleSubcategory = (slug) => {
    setOpenSubcategories((prev) => ({
      ...prev,
      [slug]: !prev[slug],
    }));
  };

  return (
    <header className="header">
      <div className="logo">
        <Link to="/" onClick={closeOffcanvas}>
        <img src={`${process.env.PUBLIC_URL}/logo.png`} width="150px" height="60px" alt="Logo" />

        </Link>
      </div>

    

      <div>
       
      <button
        className="buttonn1"
        type="button"
        onClick={() => {
          const offcanvasElement = document.getElementById('offcanvasWithBothOptions');
          const offcanvas = Offcanvas.getOrCreateInstance(offcanvasElement);
          offcanvas.show();
          setMenuOpen(true);
        }}
      >
        <FaBarsStaggered size={24} />
      </button>

      </div>
   


      <div
        className="offcanvas offcanvas-start"
        data-bs-scroll="true"
        tabIndex="-1"
        id="offcanvasWithBothOptions"
        aria-labelledby="offcanvasWithBothOptionsLabel"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasWithBothOptionsLabel">Menu</h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            onClick={closeOffcanvas}
          ></button>
        </div>

        <div className="offcanvas-body">
          {loading ? (
            <div className="loading-section">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p>Loading Categories...</p>
            </div>
          ) : (
            <nav className="menu-links">
              <NavLink to="/" onClick={closeOffcanvas} className="menu-link">Home</NavLink>

              {categories.map(cat => (
                <div key={cat.slug} className="category-section">
                  <div className="category-header">
                    <span className="category-name" onClick={() => handleCategoryClick(cat.slug)}>
                      {cat.name}
                    </span>
                    {cat.sub_categories && Object.keys(cat.sub_categories).length > 0 && (
                      <span
                        className={`arrow-toggle ${openSubcategories[cat.slug] ? 'open' : ''}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleSubcategory(cat.slug);
                        }}
                      >
                        ▼
                      </span>
                    )}
                  </div>

                  {openSubcategories[cat.slug] && (
                    <ul className="subcategory-list">
                      {Object.values(cat.sub_categories).map(sub => (
                        <li key={sub.slug} className="subcategory-item">
                          <span onClick={(e) => handleSubcategoryClick(sub.slug, e)}>
                            {sub.name}
                          </span>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}

              <NavLink to="/AboutUs" onClick={closeOffcanvas} className="menu-link">About Us</NavLink>
              <NavLink to="/ContactUs" onClick={closeOffcanvas} className="menu-link">Contact Us</NavLink>
              <div className="search-icon1" onClick={() => setIsModalOpen(!isModalOpen)}>
                <i className="fa fa-search"></i>
              </div>
              {isModalOpen && (
          <div className="modal-overlay">
            <div className="modal-content">
             
              <input
                type="text"
                className="search-input"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onKeyDown={handleSearchKeyPress}
              />
              <button onClick={handleSearch} className="search-button">Search</button>
              <button className="close-button" onClick={() => setIsModalOpen(false)}>Close</button>
            </div>
          </div>
        )}
        
            </nav>
          )}

          
        </div>
            
      </div>
      
    </header>
  );
};

export default Header;
